import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getNodeByKey } from "lexical";

export default function ImageDeletePlugin() {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        function handleClick(e) {
            // find the closest span with our class
            const target = e.target.closest(".graph_close_image");
            
            if (!target) return;
            e.stopPropagation();

            const nodeKey = target.dataset.nodeKey;
            if (!nodeKey) return;

            // 🔥 Delete the image node from Lexical
            editor.update(() => {
                const node = $getNodeByKey(nodeKey);
                if (node) node.remove();
            });
        }

        // attach global event listener
        document.addEventListener("click", handleClick);

        // cleanup on unmount
        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, [editor]);

    return null; // no UI
}
